import { FC } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';
import AuthForm from "./AuthForm";

const LoginForm: FC = () => {
  return (
    <Box sx={{
      minHeight: '100vh',
      width: '100vw',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(to bottom right, rgba(246, 154, 126, 0.3), rgba(147, 155, 236, 0.3))'
    }}>
      <Card sx={{
        width: '100%',
        maxWidth: 448,
        borderRadius: 4,
        boxShadow: '0 25px 50px -12px rgba(0, 0, 0, 0.25)',
        border: '1px solid',
        borderColor: 'grey.100'
      }}>
        <CardContent sx={{
          p: 5,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center'
        }}>
          <Typography
            variant="h3"
            component="h1"
            sx={{
              fontFamily: 'Museo',
              fontWeight: 700,
              mb: 2,
              textAlign: 'center',
              background: 'linear-gradient(to right, #F69A7E, #939BEC)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}
          >
            Login to Picasso
          </Typography>
          <Typography
            variant="body1"
            sx={{
              textAlign: 'center',
              color: 'text.secondary',
              mb: 4,
              fontFamily: 'Maven Pro'
            }}
          >
            Welcome! Sign in to continue to your dashboard.
          </Typography>
          <Box sx={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
            <AuthForm />
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default LoginForm;